module.exports = __webpack_public_path__ + "static/img/logo.a65a4ecb.jpg";